export default "__VITE_ASSET__3c79ab37__"